/** @jsx jsx */
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
import DraggableItem from './draggableItem';
import { draggableStyles } from './styles';

const Container = props => {
	const { items, handleReorder, toggleSelected } = props;
	const renderDraggableItem = (item, index) => {
		return (
			<DraggableItem
				key={item.id}
				index={index}
				item={item}
				handleReorder={handleReorder}
				toggleSelected={toggleSelected}
			/>
		);
	};

	const { itemContainer } = draggableStyles;

	return (
		<React.Fragment>
			<div css={itemContainer}>
				{items.map((item, i) => renderDraggableItem(item, i))}
			</div>
		</React.Fragment>
	);
};
export default Container;

Container.propTypes = {
	items: PropTypes.array,
	toggleSelected: PropTypes.func,
	handleReorder: PropTypes.func,
};
